import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionBusinessModel from '@/section-business-model'

import shareImg from './images/business_model.png'

class BusinessModel extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Business Model</title>
          <meta property="og:title" content="Business Model" />
          <meta property="og:description" content="Our business model is simple" />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/business_model/" />
          <meta property="og:image:alt" content="Business Model - Next Miss" />
        </Helmet>

        <SectionBusinessModel />
      </div>
    )
  }
}

export default BusinessModel



// WEBPACK FOOTER //
// ./src/pages/business_model.js